import { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import { authentication } from "@microsoft/teams-js";

const MicrosoftLoginConsentEndSSO = () => {
    useEffect(() => {
        console.log("end page 2");
        app.initialize().then((context) => {
            app.notifySuccess();
        });
        app.getContext().then((context) => {
            console.log("context:", context)
            authentication.notifySuccess();
        }).catch(error => {
            console.log("error:", error)
            authentication.notifyFailure(error.message || "An error occurred");
        })
    }, []);

    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>You have returned from Azure AD</p>
            </div>
        </div>
    );
};

export default MicrosoftLoginConsentEndSSO;
